module.exports = __webpack_public_path__ + "static/media/instagram.8b178894.png";